import useLocale, { LOCALES, type Locale } from '@/hooks/useLocale';

interface LocaleSwitcherProps {
  /** 'dark' = 白色文字（用於透明 navbar） 'light' = 深色文字（用於白色 navbar） */
  variant?: 'dark' | 'light';
  onSwitch?: () => void;
}

export default function LocaleSwitcher({ variant = 'light', onSwitch }: LocaleSwitcherProps) {
  const { locale, switchLocale } = useLocale();
  const isLight = variant === 'light';

  const visibleLocales = LOCALES.filter((l) => l.code !== 'ja');

  const handleSwitch = (code: Locale) => {
    if (code === locale) return;
    switchLocale(code);
    onSwitch?.();
  };

  return (
    <div
      className={`inline-flex items-center rounded-full border transition-all duration-200 ${
        isLight
          ? 'border-gray-200 bg-white'
          : 'border-white/40'
      }`}
    >
      {/* Globe icon */}
      <div className="w-3.5 h-3.5 flex items-center justify-center ml-2.5 mr-0.5 flex-shrink-0">
        <i className={`ri-global-line text-xs ${isLight ? 'text-gray-400' : 'text-white/70'}`} />
      </div>

      {visibleLocales.map((l, idx) => (
        <div key={l.code} className="flex items-center">
          {/* Divider between two languages */}
          {idx > 0 && (
            <span
              className={`text-[0.6875rem] select-none mx-0.5 ${
                isLight ? 'text-gray-300' : 'text-white/30'
              }`}
            >
              |
            </span>
          )}
          <button
            onClick={() => handleSwitch(l.code)}
            aria-label={`切換至${l.label}`}
            className={`whitespace-nowrap px-2.5 py-1.5 text-[0.75rem] font-semibold rounded-full transition-all duration-200 cursor-pointer ${
              l.code === locale
                ? isLight
                  ? 'bg-[#4CAF50] text-white'
                  : 'bg-white text-gray-800'
                : isLight
                  ? 'text-gray-400 hover:text-[#4CAF50]'
                  : 'text-white/70 hover:text-white'
            }`}
          >
            {l.short}
          </button>
        </div>
      ))}

      {/* Right padding spacer */}
      <span className="w-1 flex-shrink-0" />
    </div>
  );
}